import React, { CSSProperties, ReactNode, useRef } from 'react';
import style from './StepContainer.module.scss';
import { IconChevronLeft, IconClose } from '@justeattakeaway/pie-icons-react';
import PIEText from '@src/shared/components/PIEText';
import PIEButton from '@src/shared/components/PIEButton';
import { useTranslation } from 'react-i18next';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import ProgrammaticallyMobileScroller from '@src/shared/components/ProgrammaticalMobileScroller';

interface componentProps {
  title: ReactNode;
  children: ReactNode;
  totalSteps: number;
  currentStep: number;
  onClose: () => void;
  onNext: () => void;
  onPrevious?: () => void;
  width?: string;
  marginX?: string;
  marginTop?: string;
  customStyle?: CSSProperties;
}
const StepContainer = ({
  children,
  width,
  marginX,
  marginTop,
  title,
  currentStep,
  totalSteps,
  onClose,
  onPrevious,
  onNext,
  customStyle = {},
}: componentProps) => {
  const { t } = useTranslation();
  const { isResolutionMobileInstantCheck } = useDeviceDetect();
  const scrollerParent = useRef(null);
  return (
    <div
      style={{
        ...customStyle,
        width: `${width ? `${width}` : 'auto'}`,
        marginLeft: marginX ? `${marginX}` : '',
        marginRight: marginX ? `${marginX}` : '',
        marginTop: marginTop ? `${marginTop}` : '',
      }}
      className={style.StepContainer}
    >
      <div className={style.StepContainerHeader}>
        {title}
        <div className={style.StepContainerHeaderCloseIcon}>
          <IconClose size="s" color="var(--xds-color-content-light)" onClick={() => onClose()} />
        </div>
      </div>
      <div className={style.StepContainerContent}>
        {isResolutionMobileInstantCheck() ? (
          <ProgrammaticallyMobileScroller height={screen.height <= 750 ? 155 : 205}>
            {children}
          </ProgrammaticallyMobileScroller>
        ) : (
          children
        )}
      </div>
      <div className={style.StepContainerFooter}>
        <div className={style.StepContainerFooterLeftContainer}>
          {currentStep !== 1 && (
            <IconChevronLeft
              onClick={() => onPrevious && onPrevious()}
              className={style.StepContainerFooterLeftContainerBackButton}
              size="xs"
              color="var(--xds-color-content-light)"
            />
          )}
          <PIEText
            text={t('onboarding_dashboard.STEP', {
              currentStep,
              totalStep: totalSteps,
            })}
            size="var(--xds-font-size-14)"
            align="left"
            color="var(--xds-color-content-light)"
            fontWeight="var(--xds-font-weight-regular)"
          />
        </div>
        <div className={style.StepContainerFooterRightContainer}>
          <PIEButton
            type="submit"
            mode="primary"
            size="small"
            text={t('onboarding_dashboard.NEXT')}
            autoWidth={true}
            onClick={() => onNext()}
          />
        </div>
      </div>
    </div>
  );
};

export default StepContainer;
